module.exports = __webpack_public_path__ + "static/media/MobileHeroImg.511ec6f0.svg";